import Button from "@ch/components/Buttons/Button.tsx";
import Modal from "@ch/components/Modals/Modal.tsx";
import CheckMarkIcon3 from "@ch/assets/icons/pack/CheckmarkIcon3.tsx";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";

interface IProps {
  modalId: string;
  onClose: () => void;
  isDialogueOpen: boolean;
  title?: string;
}

function WelcomeProjectModal({
  modalId,
  onClose,
  isDialogueOpen,
  title,
}: IProps) {
  const { programId } = useParams();
  const [searchParams] = useSearchParams();
  const subscriptionId = searchParams.get("subscriptionId");
  const navigate = useNavigate();
  const handleClickOk = () => {
    onClose();

    if (subscriptionId && programId) {
      void navigate(
        `/subscriptions/${subscriptionId}/program/${programId}/BLA/start`,
      );
      return;
    }
    void navigate("/subscriptions");
  };

  const projectTitle = title ? <span>&ldquo;{title}&rdquo; </span> : "";

  return (
    <Modal
      footerComponent={
        <div className="flex items-center justify-center gap-4 pt-4">
          <Button
            className="w-[140px] gap-2 px-5"
            onClick={handleClickOk}
            shape="pill"
          >
            Ok
          </Button>
        </div>
      }
      isModalOpen={isDialogueOpen}
      modalBoxClassName="max-w-[740px] !h-fit"
      modalId={modalId}
      onDismiss={onClose}
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-green-200 text-green">
          <CheckMarkIcon3 height={24} width={24} />
        </div>
        <h2 className="text-2xl font-semibold leading-snug text-black md:text-2xl">
          🎉 Welcome Aboard! You&apos;re Officially Enrolled! 🎉
        </h2>
        <p className="text-base leading-relaxed text-gray">
          Congratulations and a huge welcome to the {projectTitle}
          clinical study! We are absolutely thrilled to have you get started
          with your health journey. Here&apos;s what happens next:
        </p>
        <p className="text-base leading-relaxed text-gray">
          A dedicated personal coach will be assigned to you shortly &mdash;
          They will reach out to you soon to introduce themselves, answer your
          questions, and help you feel confident and supported every step of the
          way. Meanwhile, please complete baseline assessments (BLA) on the next
          page. This will help us guide you better in your health journey.
          Welcome to the team!
        </p>
      </div>
    </Modal>
  );
}

export default WelcomeProjectModal;
